module.exports = __webpack_public_path__ + "img/view-count.83da42f8.svg";